<template>
<div class="acomodar">
    <Tecnologia/>
</div>
</template>

<script>
import Tecnologia from "@/components/ModTecnologia/Tecnologia.vue";
import "@/assets/styles/global-acomodar.css"; // Importar el estilo global
export default {
  name: 'CopiasCorreosdeTecnologia',
  components: {
    Tecnologia
  },
  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>
